<ng-content select=".left"></ng-content>
<label class="switch" [class.active]="toggleValue">
    <input type="checkbox" [checked]="toggleValue" (change)="toggle()">
    <div class="slider round">
        <div class="slider-switch"></div>
    </div>
</label>
<ng-content select=".right"></ng-content>